// test2617
(2617 && 0);
